export const mockCelebrities = {
  // FULL DATA - These 3 have complete profiles
  "106033-87": {
    investor_name: "Ashton Kutcher",
    investor_pb_id: "106033-87",
    display_role: "Co-Founder, Sound Ventures",
    total_investments: 123,
    active_portfolio: 60,
    total_exits: 57,
    exit_rate: "46.3",
    median_round_amount: 7730000,
    median_valuation: 54502000,
    total_invested_active: 3100515600,
    total_invested_previous: 0,
    latest_company: "Ephemera (Communication Software)",
    latest_investment_timeago: "This month",
    preferred_industries: [
      "Business/Productivity Software",
      "Other Financial Services",
      "Social/Platform Software"
    ],
    activity_tier: "Mega Active",
    recent_deals: [
      {
        deal_id: "deal-ak-1",
        company_name: "Ephemera (Communication Software)",
        company_id: "472182-04",
        deal_number: 1,
        deal_date: "2025-07-21",
        round_type: "Early Stage VC",
        amount_invested: 20000000,
        total_round_size: 20000000,
        post_money_valuation: 50000000,
        ownership_percentage: "1.74",
        lead_investor: "Ashton Kutcher",
        industry: "Communication Software",
        location: "San Francisco, CA",
        deal_synopsis: "Ephemera (Communication Software) raised $20.0 million in Early Stage VC on July 21, 2025. The round included participation from Ashton Kutcher, Octant Ventures, Union Square Ventures and 7 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Shane McSimov",
        investors: [
          {
            name: "Ashton Kutcher",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Octant Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Union Square Ventures",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "United Airlines Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Faction Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Andreessen Horowitz",
            status: "New Investor",
            lead: false
          },
          {
            name: "Coinbase Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Distributed Global",
            status: "New Investor",
            lead: false
          },
          {
            name: "Offline Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Sound Ventures",
            status: "New Investor",
            lead: false
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 1123339,
          runway_months: 16
        }
      },
      {
        deal_id: "deal-ak-2",
        company_name: "Spicewell",
        company_id: "514824-85",
        deal_number: 2,
        deal_date: "2024-09-26",
        round_type: "Seed",
        amount_invested: 1000000,
        total_round_size: 10000000,
        post_money_valuation: 50000000,
        ownership_percentage: "0.86",
        lead_investor: "Ashton Kutcher",
        industry: "Food Products",
        location: "San Francisco, CA",
        deal_synopsis: "Spicewell raised $10.0 million in Seed on September 26, 2024. The round included participation from Ashton Kutcher, Entrepreneur Ventures (Fund), Fabric VC and 5 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Raina Kumra",
        investors: [
          {
            name: "Ashton Kutcher",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Entrepreneur Ventures (Fund)",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Fabric VC",
            status: "New Investor",
            lead: false
          },
          {
            name: "Furthermore Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Joanne Bradford",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Joyance Partners",
            status: "New Investor",
            lead: false
          },
          {
            name: "Mila Kunis",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Path Ahead Ventures",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 250000,
          ebitda: 0,
          net_income: 0,
          burn_rate: 2359764,
          runway_months: 31
        }
      },
      {
        deal_id: "deal-ak-3",
        company_name: "World Labs",
        company_id: "608754-43",
        deal_number: 3,
        deal_date: "2024-09-13",
        round_type: "Series B",
        amount_invested: 230000000,
        total_round_size: 230000000,
        post_money_valuation: 1000000000,
        ownership_percentage: "1.83",
        lead_investor: "Andrej Karpathy",
        industry: "Business/Productivity Software",
        location: "San Francisco, CA",
        deal_synopsis: "World Labs raised $230.0 million in Series B on September 13, 2024. The round included participation from Adobe Ventures, AMD Ventures, Andrej Karpathy and 22 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Fei-Fei Li",
        investors: [
          {
            name: "Adobe Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "AMD Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Andrej Karpathy",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Anne Wojcicki",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Ashton Kutcher",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Databricks Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Eric Schmidt",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Geoffrey Hinton",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Intel Capital",
            status: "New Investor",
            lead: false
          },
          {
            name: "Jeff Dean",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 1089272,
          runway_months: 35
        }
      },
      {
        deal_id: "deal-ak-4",
        company_name: "Unrivaled Basketball",
        company_id: "600361-30",
        deal_number: 4,
        deal_date: "2024-05-30",
        round_type: "Seed",
        amount_invested: 7000000,
        total_round_size: 7000000,
        post_money_valuation: 50000000,
        ownership_percentage: "2.38",
        lead_investor: "Alex Morgan",
        industry: "Other Restaurants, Hotels and Leisure",
        location: "San Francisco, CA",
        deal_synopsis: "Unrivaled Basketball raised $7.0 million in Seed on May 30, 2024. The round included participation from Alex Morgan, Ann Sarnoff, Ashton Kutcher and 15 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Breanna Stewart",
        investors: [
          {
            name: "Alex Morgan",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Ann Sarnoff",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Ashton Kutcher",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Carmelo Anthony",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Dan Benton",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Daniel Rosensweig",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Desiree Gruber",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Gary Vaynerchuk",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Geno Auriemma",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Horizon Sports & Experiences",
            status: "New Investor",
            lead: false
          }
        ],
        financials: {
          revenue_ttm: 27000000,
          ebitda: 0,
          net_income: 0,
          burn_rate: 2305504,
          runway_months: 18
        }
      },
      {
        deal_id: "deal-ak-5",
        company_name: "PearPop",
        company_id: "439482-61",
        deal_number: 5,
        deal_date: "2022-11-29",
        round_type: "Series A",
        amount_invested: 28000000,
        total_round_size: 28000000,
        post_money_valuation: 300000000,
        ownership_percentage: "1.11",
        lead_investor: "Abel Tesfaye",
        industry: "Social/Platform Software",
        location: "San Francisco, CA",
        deal_synopsis: "PearPop raised $28.0 million in Series A on November 29, 2022. The round included participation from Abel Tesfaye, Amy Schumer, Anti Fund and 31 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Cole Mason",
        investors: [
          {
            name: "Abel Tesfaye",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Amy Schumer",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Anti Fund",
            status: "New Investor",
            lead: false
          },
          {
            name: "Ashton Kutcher",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Ava Labs",
            status: "New Investor",
            lead: false
          },
          {
            name: "Bessemer Venture Partners",
            status: "New Investor",
            lead: false
          },
          {
            name: "Blizzard Avalanche Fund",
            status: "New Investor",
            lead: false
          },
          {
            name: "Blockchange Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Calm Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Calvin Broadus",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 1335388,
          runway_months: 19
        }
      }
    ],
    investments: [
      {
        company_name: "Ephemera (Communication Software)",
        company_id: "472182-04",
        status: "Active",
        initial_investment: 20000000,
        current_value: 110008916,
        multiple: "5.5",
        industry: "Communication Software",
        investment_date: "2025-07-21",
        round_type: "Early Stage VC"
      },
      {
        company_name: "Spicewell",
        company_id: "514824-85",
        status: "Active",
        initial_investment: 2000000,
        current_value: 6475733,
        multiple: "3.2",
        industry: "Food Products",
        investment_date: "2024-09-26",
        round_type: "Seed"
      },
      {
        company_name: "World Labs",
        company_id: "608754-43",
        status: "Active",
        initial_investment: 230000000,
        current_value: 1025360049,
        multiple: "4.5",
        industry: "Business/Productivity Software",
        investment_date: "2024-09-13",
        round_type: "Series B"
      },
      {
        company_name: "Unrivaled Basketball",
        company_id: "600361-30",
        status: "Active",
        initial_investment: 7000000,
        current_value: 31996639,
        multiple: "4.6",
        industry: "Other Restaurants, Hotels and Leisure",
        investment_date: "2024-05-30",
        round_type: "Seed"
      },
      {
        company_name: "PearPop",
        company_id: "439482-61",
        status: "Active",
        initial_investment: 28000000,
        current_value: 171333099,
        multiple: "6.1",
        industry: "Social/Platform Software",
        investment_date: "2022-11-29",
        round_type: "Series A"
      },
      {
        company_name: "NobleAI",
        company_id: "227738-26",
        status: "Active",
        initial_investment: 23051560,
        current_value: 123820047,
        multiple: "5.4",
        industry: "Business/Productivity Software",
        investment_date: "2022-06-24",
        round_type: "Series A"
      }
    ],
    exits: [
      {
        company_name: "Lolli",
        company_id: "234747-73",
        exit_type: "Merger/Acquisition",
        exit_date: "2025-07-02",
        initial_investment: 3904241,
        exit_value: 12661407,
        multiple: "3.2",
        holding_period_years: "6.4",
        acquirer: "Google"
      },
      {
        company_name: "Superhuman",
        company_id: "123088-33",
        exit_type: "Merger/Acquisition",
        exit_date: "2025-06-30",
        initial_investment: 2755658,
        exit_value: 34257727,
        multiple: "12.4",
        holding_period_years: "3.1",
        acquirer: "Google"
      },
      {
        company_name: "Saturn",
        company_id: "279549-91",
        exit_type: "Merger/Acquisition",
        exit_date: "2025-06-20",
        initial_investment: 5186925,
        exit_value: 29802778,
        multiple: "5.7",
        holding_period_years: "4.4",
        acquirer: "Meta"
      }
    ],
    co_investors: [
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      }
    ],
    has_full_data: true
  },
  
  "105876-55": {
    investor_name: "Jared Leto",
    investor_pb_id: "105876-55",
    display_role: "Executive, Frame.io",
    total_investments: 43,
    active_portfolio: 16,
    total_exits: 23,
    exit_rate: 53.5,
    median_round_amount: 30000000,
    median_valuation: 157999999,
    total_invested_active: 350515050,
    total_invested_previous: 721875047,
    latest_company: "Aetherflux",
    latest_investment_timeago: "4 months ago",
    preferred_industries: ["Other Financial Services", "Business/Productivity Software", "Aerospace and Defense"],
    activity_tier: "Active",
    has_full_data: true,
    
    recent_deals: [
      {
        deal_id: "deal-jl-1",
        deal_number: 1,
        company_name: "Aetherflux",
        company_id: "719403-94",
        deal_date: "2025-04-02",
        round_type: "Series A",
        amount_invested: 49999810,
        total_round_size: 49999810,
        post_money_valuation: 499998100,
        ownership_percentage: 0.50,
        lead_investor: "Jared Leto",
        deal_synopsis: "Aetherflux raised USD 50.0M in Series A funding on April 2, 2025. The round was led by institutional investors.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Active",
        ceo: "Not Available",
        industry: "Aerospace and Defense",
        location: "United States",
        investors: [
          {
            name: "Jared Leto",
            status: "Angel Investor",
            lead: false
          }
        ],
        vc_round: "Series A",
        financials: {
          revenue_ttm: 48487896,
          growth_rate: 63.0,
          burn_rate: 1057259,
          runway_months: 16
        }
      },
      {
        deal_id: "deal-jl-2",
        deal_number: 2,
        company_name: "Harmonic (Educational Software)",
        company_id: "608847-76",
        deal_date: "2024-09-23",
        round_type: "Series A",
        amount_invested: 75000000,
        total_round_size: 75000000,
        post_money_valuation: 750000000,
        ownership_percentage: 0.50,
        lead_investor: "Jared Leto",
        deal_synopsis: "Harmonic (Educational Software) raised USD 75.0M in Series A funding on September 23, 2024. The round was led by institutional investors.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Active",
        ceo: "Not Available",
        industry: "Educational Software",
        location: "United States",
        investors: [
          {
            name: "Jared Leto",
            status: "Angel Investor",
            lead: false
          }
        ],
        vc_round: "Series A",
        financials: {
          revenue_ttm: 22878750,
          growth_rate: 72.1,
          burn_rate: 1411681,
          runway_months: 18
        }
      },
      {
        deal_id: "deal-jl-3",
        deal_number: 3,
        company_name: "Pika (Multimedia and Design Software)",
        company_id: "537093-55",
        deal_date: "2024-07-23",
        round_type: "Series B",
        amount_invested: 80000000,
        total_round_size: 80000000,
        post_money_valuation: 800000000,
        ownership_percentage: 0.50,
        lead_investor: "Jared Leto",
        deal_synopsis: "Pika (Multimedia and Design Software) raised USD 80.0M in Series B funding on July 23, 2024. The round was led by institutional investors.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Active",
        ceo: "Not Available",
        industry: "Multimedia and Design Software",
        location: "United States",
        investors: [
          {
            name: "Jared Leto",
            status: "Angel Investor",
            lead: false
          }
        ],
        vc_round: "Series B",
        financials: {
          revenue_ttm: 46428186,
          growth_rate: 42.8,
          burn_rate: 1596501,
          runway_months: 23
        }
      },
      {
        deal_id: "deal-jl-4",
        deal_number: 4,
        company_name: "X1 Card",
        company_id: "439120-90",
        deal_date: "2022-12-01",
        round_type: "Series B",
        amount_invested: 40000000,
        total_round_size: 40000000,
        post_money_valuation: 400000000,
        ownership_percentage: 0.50,
        lead_investor: "Jared Leto",
        deal_synopsis: "X1 Card raised USD 40.0M in Series B funding on December 1, 2022. The round was led by institutional investors.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Active",
        ceo: "Not Available",
        industry: "Other Financial Services",
        location: "United States",
        investors: [
          {
            name: "Jared Leto",
            status: "Angel Investor",
            lead: false
          }
        ],
        vc_round: "Series B",
        financials: {
          revenue_ttm: 9285694,
          growth_rate: 146.1,
          burn_rate: 699531,
          runway_months: 14
        }
      },
      {
        deal_id: "deal-jl-5",
        deal_number: 5,
        company_name: "ZeroEx (San Francisco)",
        company_id: "183309-13",
        deal_date: "2022-04-15",
        round_type: "Series B",
        amount_invested: 70000000,
        total_round_size: 70000000,
        post_money_valuation: 700000000,
        ownership_percentage: 0.50,
        lead_investor: "Jared Leto",
        deal_synopsis: "ZeroEx (San Francisco) raised USD 70.0M in Series B funding on April 15, 2022. The round was led by institutional investors.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Active",
        ceo: "Not Available",
        industry: "Financial Software",
        location: "United States",
        investors: [
          {
            name: "Jared Leto",
            status: "Angel Investor",
            lead: false
          }
        ],
        vc_round: "Series B",
        financials: {
          revenue_ttm: 36530691,
          growth_rate: 92.4,
          burn_rate: 1862392,
          runway_months: 30
        }
      }
    ],
    
    investments: [
      {
        company_name: "Aetherflux",
        company_id: "719403-94",
        status: "Active",
        initial_investment: 49999810,
        current_value: 266303094,
        exit_value: null,
        multiple: 5.3,
        industry: "Aerospace and Defense",
        investment_date: "2025-04-02",
        round_type: "Series A",
        co_investors_count: 5,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "Harmonic (Educational Software)",
        company_id: "608847-76",
        status: "Active",
        initial_investment: 75000000,
        current_value: 459235530,
        exit_value: null,
        multiple: 6.1,
        industry: "Educational Software",
        investment_date: "2024-09-23",
        round_type: "Series A",
        co_investors_count: 6,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "Pika (Multimedia and Design Software)",
        company_id: "537093-55",
        status: "Active",
        initial_investment: 80000000,
        current_value: 472383553,
        exit_value: null,
        multiple: 5.9,
        industry: "Multimedia and Design Software",
        investment_date: "2024-07-23",
        round_type: "Series B",
        co_investors_count: 3,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "ZeroEx (San Francisco)",
        company_id: "183309-13",
        status: "Active",
        initial_investment: 70000000,
        current_value: 395684766,
        exit_value: null,
        multiple: 5.7,
        industry: "Financial Software",
        investment_date: "2022-04-15",
        round_type: "Series B",
        co_investors_count: 5,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "Propel (Financial Software)",
        company_id: "155056-06",
        status: "Active",
        initial_investment: 55515246,
        current_value: 297838916,
        exit_value: null,
        multiple: 5.4,
        industry: "Financial Software",
        investment_date: "2022-02-02",
        round_type: "Series B",
        co_investors_count: 6,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "Superplastic",
        company_id: "233790-67",
        status: "Active",
        initial_investment: 19999994,
        current_value: 103707307,
        exit_value: null,
        multiple: 5.2,
        industry: "Recreational Goods",
        investment_date: "2021-10-20",
        round_type: "Series A",
        co_investors_count: 3,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "X1 Card",
        company_id: "439120-90",
        status: "Exited",
        initial_investment: 40000000,
        current_value: 120000000,
        exit_value: 120000000,
        multiple: 3.0,
        industry: "Other Financial Services",
        investment_date: "2022-12-01",
        round_type: "Series B",
        co_investors_count: 6,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "Rupa Health",
        company_id: "266180-68",
        status: "Exited",
        initial_investment: 19875044,
        current_value: 59625132,
        exit_value: 59625132,
        multiple: 3.0,
        industry: "Other Healthcare Technology Systems",
        investment_date: "2022-03-01",
        round_type: "Series A",
        co_investors_count: 3,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "Relativity Space",
        company_id: "102075-04",
        status: "Exited",
        initial_investment: 650000003,
        current_value: 1950000009,
        exit_value: 1950000009,
        multiple: 3.0,
        industry: "Aerospace and Defense",
        investment_date: "2021-06-08",
        round_type: "Series E",
        co_investors_count: 2,
        lead_partner: "Jared Leto"
      },
      {
        company_name: "PayRange",
        company_id: "63828-10",
        status: "Exited",
        initial_investment: 12000000,
        current_value: 36000000,
        exit_value: 36000000,
        multiple: 3.0,
        industry: "Other Financial Services",
        investment_date: "2021-01-14",
        round_type: "Early Stage VC",
        co_investors_count: 6,
        lead_partner: "Jared Leto"
      }
    ],
    
    exits: [
      {
        company_name: "Relativity Space",
        exit_type: "Merger/Acquisition",
        exit_date: "2025-03-11",
        initial_investment: 1000000,
        exit_value: 5000000,
        multiple: 5.0,
        holding_period_years: 3.5,
        acquirer: "",
        buyers: ""
      },
      {
        company_name: "Rupa Health",
        exit_type: "Buyout/LBO (Add-on)",
        exit_date: "2024-10-08",
        initial_investment: 1000000,
        exit_value: 5000000,
        multiple: 5.0,
        holding_period_years: 3.5,
        acquirer: "",
        buyers: ""
      },
      {
        company_name: "PayRange",
        exit_type: "Buyout/LBO",
        exit_date: "2024-09-30",
        initial_investment: 1000000,
        exit_value: 5000000,
        multiple: 5.0,
        holding_period_years: 3.5,
        acquirer: "",
        buyers: ""
      },
      {
        company_name: "Gobbler",
        exit_type: "Out of Business",
        exit_date: "2024-08-09",
        initial_investment: 1000000,
        exit_value: 5000000,
        multiple: 5.0,
        holding_period_years: 3.5,
        acquirer: "",
        buyers: ""
      },
      {
        company_name: "Reddit",
        exit_type: "IPO",
        exit_date: "2024-03-21",
        initial_investment: 1000000,
        exit_value: 5000000,
        multiple: 5.0,
        holding_period_years: 3.5,
        acquirer: "",
        buyers: ""
      }
    ],
    
    co_investors: [
      {
        name: "The Chainsmokers",
        shared_deals: 7,
        firm: "The Chainsmokers",
        notable_co_investments: ["Various startups"],
        with: 3,
        series: "Series A-C",
        lead_partner: 1
      },
      {
        name: "Coatue Management",
        shared_deals: 8,
        firm: "Coatue Management",
        notable_co_investments: ["Various startups"],
        with: 12,
        series: "Series A-C",
        lead_partner: 1
      },
      {
        name: "Mantis VC",
        shared_deals: 7,
        firm: "Mantis VC",
        notable_co_investments: ["Various startups"],
        with: 9,
        series: "Series A-C",
        lead_partner: 3
      },
      {
        name: "Andreessen Horowitz",
        shared_deals: 8,
        firm: "Andreessen Horowitz",
        notable_co_investments: ["Various startups"],
        with: 6,
        series: "Series A-C",
        lead_partner: 3
      },
      {
        name: "Index Ventures",
        shared_deals: 11,
        firm: "Index Ventures",
        notable_co_investments: ["Various startups"],
        with: 10,
        series: "Series A-C",
        lead_partner: 3
      }
    ],
    
    financial_metrics: {
      total_invested: 1072390097,
      total_realized_gains: 1804687617,
      total_unrealized_gains: 630927090,
      gross_multiple: 2.2,
      irr: 28.5,
      hit_rate: 53.5,
      average_holding_period: 4.5
    }
  },
  
  "162886-33": {
    investor_name: "Gwyneth Paltrow",
    investor_pb_id: "162886-33",
    display_role: "Founder & Chief Executive Officer, Goop (Personal Products)",
    total_investments: 25,
    active_portfolio: 19,
    total_exits: 6,
    exit_rate: "24.0",
    median_round_amount: 9934230,
    median_valuation: 45000001,
    total_invested_active: 35000000,
    total_invested_previous: 10000000,
    latest_company: "Forethought",
    latest_investment_timeago: "3 months ago",
    preferred_industries: [
      "Beverages",
      "Personal Products",
      "Business/Productivity Software"
    ],
    activity_tier: "Active",
    recent_deals: [
      {
        deal_id: "deal-gp-1",
        company_name: "Forethought",
        company_id: "223431-67",
        deal_number: 1,
        deal_date: "2025-04-07",
        round_type: "Series D",
        amount_invested: 1249999.55,
        total_round_size: 24999991,
        post_money_valuation: 110000000,
        ownership_percentage: "0.56",
        lead_investor: "Blue Cloud Ventures",
        industry: "Business/Productivity Software",
        location: "Los Angeles, CA",
        deal_synopsis: "Forethought raised $25.0 million in Series D on April 7, 2025. The round included participation from Blue Cloud Ventures, Industry Ventures, Karan Goel and 7 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Deon Nicholas",
        investors: [
          {
            name: "Blue Cloud Ventures",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Industry Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Karan Goel",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "May Habib",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Scott Wu",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Gwyneth Paltrow",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Neo (Consulting Services (B2B))",
            status: "New Investor",
            lead: false
          },
          {
            name: "New Enterprise Associates",
            status: "New Investor",
            lead: false
          },
          {
            name: "Sound Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Village Global",
            status: "New Investor",
            lead: false
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 888792,
          runway_months: 46
        }
      },
      {
        deal_id: "deal-gp-2",
        company_name: "Kudos (Personal Products)",
        company_id: "343114-03",
        deal_number: 2,
        deal_date: "2024-07-11",
        round_type: "Seed",
        amount_invested: 190000.05,
        total_round_size: 3800001,
        post_money_valuation: 18000001,
        ownership_percentage: "0.15",
        lead_investor: "Alumni Ventures",
        industry: "Personal Products",
        location: "Los Angeles, CA",
        deal_synopsis: "Kudos (Personal Products) raised $3.8 million in Seed on July 11, 2024. The round included participation from Alumni Ventures, Five Two Five, Freedom Trail Capital and 6 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Amrita Saigal",
        investors: [
          {
            name: "Alumni Ventures",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Five Two Five",
            status: "New Investor",
            lead: false
          },
          {
            name: "Freedom Trail Capital",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Gwyneth Paltrow",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Mark Cuban",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Net Zero Angels",
            status: "New Investor",
            lead: false
          },
          {
            name: "Oversubscribed Ventures",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Precursor Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Xfund",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 850000,
          ebitda: 0,
          net_income: 0,
          burn_rate: 290534,
          runway_months: 19
        }
      },
      {
        deal_id: "deal-gp-3",
        company_name: "Wild",
        company_id: "521393-59",
        deal_number: 3,
        deal_date: "2023-03-09",
        round_type: "Seed",
        amount_invested: 350000,
        total_round_size: 7000000,
        post_money_valuation: 50000000,
        ownership_percentage: "0.61",
        lead_investor: "Cozomo de' Medici",
        industry: "Social/Platform Software",
        location: "Los Angeles, CA",
        deal_synopsis: "Wild raised $7.0 million in Seed on March 9, 2023. The round included participation from Cozomo de' Medici, Gwyneth Paltrow, Kevin Lin and 3 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "John Kobs",
        investors: [
          {
            name: "Cozomo de' Medici",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Gwyneth Paltrow",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Kevin Lin",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Matrix",
            status: "New Investor",
            lead: false
          },
          {
            name: "Reid Hoffman",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Western Technology Investment",
            status: "New Investor",
            lead: false
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 714734,
          runway_months: 12
        }
      },
      {
        deal_id: "deal-gp-4",
        company_name: "ResortPass",
        company_id: "233310-25",
        deal_number: 4,
        deal_date: "2022-10-19",
        round_type: "Series B",
        amount_invested: 1299999.2,
        total_round_size: 25999984,
        post_money_valuation: 90999985,
        ownership_percentage: "0.74",
        lead_investor: "14W",
        industry: "Other Restaurants, Hotels and Leisure",
        location: "Los Angeles, CA",
        deal_synopsis: "ResortPass raised $26.0 million in Series B on October 19, 2022. The round included participation from 14W, Adam Grant, AirAngels and 10 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "N/A",
        investors: [
          {
            name: "14W",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Adam Grant",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "AirAngels",
            status: "New Investor",
            lead: false
          },
          {
            name: "Brian Kelly",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Burst Capital",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Declaration Partners",
            status: "New Investor",
            lead: false
          },
          {
            name: "Endeavor Group Holdings",
            status: "New Investor",
            lead: false
          },
          {
            name: "FJ Labs",
            status: "New Investor",
            lead: false
          },
          {
            name: "Gwyneth Paltrow",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Jessica Warren",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 801341,
          runway_months: 28
        }
      },
      {
        deal_id: "deal-gp-5",
        company_name: "Evernow",
        company_id: "432851-68",
        deal_number: 5,
        deal_date: "2022-09-30",
        round_type: "Series A",
        amount_invested: 1425000,
        total_round_size: 28500000,
        post_money_valuation: 50000000,
        ownership_percentage: "0.19",
        lead_investor: "8VC",
        industry: "Other Healthcare Technology Systems",
        location: "Los Angeles, CA",
        deal_synopsis: "Evernow raised $28.5 million in Series A on September 30, 2022. The round included participation from 8VC, Alumni Ventures, Cameron Diaz and 19 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Alicia Jackson",
        investors: [
          {
            name: "8VC",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Alumni Ventures",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Cameron Diaz",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Carla Harris",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Demi Moore",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Drew Barrymore",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Gaingels",
            status: "New Investor",
            lead: false
          },
          {
            name: "Gwyneth Paltrow",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Hands On Angel",
            status: "New Investor",
            lead: false
          },
          {
            name: "Liza Landsman",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 1137267,
          runway_months: 26
        }
      }
    ],
    investments: [
      {
        company_name: "Forethought",
        company_id: "223431-67",
        status: "Active",
        initial_investment: 1249999.55,
        current_value: 3559987,
        multiple: "2.8",
        industry: "Business/Productivity Software",
        investment_date: "2025-04-07",
        round_type: "Series D"
      },
      {
        company_name: "Kudos (Personal Products)",
        company_id: "343114-03",
        status: "Active",
        initial_investment: 190000.05,
        current_value: 407182,
        multiple: "2.1",
        industry: "Personal Products",
        investment_date: "2024-07-11",
        round_type: "Seed"
      },
      {
        company_name: "Wild",
        company_id: "521393-59",
        status: "Active",
        initial_investment: 350000,
        current_value: 1444465,
        multiple: "4.1",
        industry: "Social/Platform Software",
        investment_date: "2023-03-09",
        round_type: "Seed"
      },
      {
        company_name: "ResortPass",
        company_id: "233310-25",
        status: "Active",
        initial_investment: 1299999.2,
        current_value: 5261559,
        multiple: "4.0",
        industry: "Other Restaurants, Hotels and Leisure",
        investment_date: "2022-10-19",
        round_type: "Series B"
      },
      {
        company_name: "Evernow",
        company_id: "432851-68",
        status: "Active",
        initial_investment: 1425000,
        current_value: 6257926,
        multiple: "4.4",
        industry: "Other Healthcare Technology Systems",
        investment_date: "2022-09-30",
        round_type: "Series A"
      },
      {
        company_name: "Crown Affair",
        company_id: "392361-04",
        status: "Active",
        initial_investment: 374523.95,
        current_value: 1265891,
        multiple: "3.4",
        industry: "Personal Products",
        investment_date: "2022-05-13",
        round_type: "Series A"
      }
    ],
    exits: [
      {
        company_name: "Daily Harvest",
        company_id: "85706-92",
        exit_type: "Buyout/LBO (Add-on)",
        exit_date: "2025-05-16",
        initial_investment: 684920,
        exit_value: 3198939,
        multiple: "4.7",
        holding_period_years: "4.2",
        acquirer: "Nestle"
      },
      {
        company_name: "Zeera",
        company_id: "343531-72",
        exit_type: "Merger/Acquisition",
        exit_date: "2025-02-11",
        initial_investment: 474370,
        exit_value: 2277482,
        multiple: "4.8",
        holding_period_years: "2.5",
        acquirer: "P&G"
      },
      {
        company_name: "Thirteen Lune",
        company_id: "455234-05",
        exit_type: "Merger/Acquisition",
        exit_date: "2024-12-23",
        initial_investment: 1139701,
        exit_value: 7309114,
        multiple: "6.4",
        holding_period_years: "4.1",
        acquirer: "Unilever"
      }
    ],
    co_investors: [
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      }
    ],
    has_full_data: true
  },
  
    "106345-45": {
    investor_name: "Justin Bieber",
    investor_pb_id: "106345-45",
    display_role: "Angel Investor, Angel Investor",
    total_investments: 10,
    active_portfolio: 5,
    total_exits: 5,
    exit_rate: "50.0",
    median_round_amount: 12500000,
    median_valuation: 99500000,
    total_invested_active: 25000000,
    total_invested_previous: 0,
    latest_company: "TMRW Sports",
    latest_investment_timeago: "2 years ago",
    preferred_industries: [
      "Other Devices and Supplies",
      "Media and Information Services (B2B)",
      "Publishing"
    ],
    activity_tier: "Moderate",
    recent_deals: [
      {
        deal_id: "deal-gp-1",
        company_name: "TMRW Sports",
        company_id: "506937-88",
        deal_number: 1,
        deal_date: "2023-03-21",
        round_type: "Early Stage VC",
        amount_invested: 750000,
        total_round_size: 15000000,
        post_money_valuation: 50000000,
        ownership_percentage: "0.31",
        lead_investor: "Alex Albon",
        industry: "Publishing",
        location: "Los Angeles, CA",
        deal_synopsis: "TMRW Sports raised $15.0 million in Early Stage VC on March 21, 2023. The round included participation from 25madison, Alex Albon, Alex Morgan and 41 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Katie Fitzpatrick",
        investors: [
          {
            name: "25madison",
            status: "New Investor",
            lead: false
          },
          {
            name: "Alex Albon",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Alex Morgan",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "AMBSE Ventures",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Apex Capital (Portugal)",
            status: "New Investor",
            lead: false
          },
          {
            name: "AyBe",
            status: "New Investor",
            lead: false
          },
          {
            name: "Carlos Sainz",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Connect Ventures (Venture Capital)",
            status: "New Investor",
            lead: false
          },
          {
            name: "Darius Rucker",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Dick Ebersol",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 0,
          ebitda: 0,
          net_income: 0,
          burn_rate: 472664,
          runway_months: 47
        }
      },
      {
        deal_id: "deal-gp-2",
        company_name: "Legacy (Devices and Supplies)",
        company_id: "232830-28",
        deal_number: 2,
        deal_date: "2022-05-12",
        round_type: "Series B",
        amount_invested: 1250000.1,
        total_round_size: 25000002,
        post_money_valuation: 150000001,
        ownership_percentage: "0.99",
        lead_investor: "FirstMark Capital",
        industry: "Other Devices and Supplies",
        location: "Los Angeles, CA",
        deal_synopsis: "Legacy (Devices and Supplies) raised $25.0 million in Series B on May 12, 2022. The round included participation from Duro Ventures, Pres10 Ventures, Reform Ventures and 12 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Khaled Kteily",
        investors: [
          {
            name: "Duro Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Pres10 Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Reform Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Tamar Capital",
            status: "New Investor",
            lead: false
          },
          {
            name: "Valor Equity Partners",
            status: "New Investor",
            lead: false
          },
          {
            name: "Valspring Capital",
            status: "New Investor",
            lead: false
          },
          {
            name: "FirstMark Capital",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Justin Bieber",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Khaled Mohamed Khaled",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Orlando Bloom",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 4321,
          ebitda: 0,
          net_income: 0,
          burn_rate: 956962,
          runway_months: 29
        }
      },
      {
        deal_id: "deal-gp-3",
        company_name: "MoonPay USA",
        company_id: "266376-70",
        deal_number: 3,
        deal_date: "2022-04-13",
        round_type: "Series A",
        amount_invested: 27750000,
        total_round_size: 555000000,
        post_money_valuation: 3400000000,
        ownership_percentage: "0.43",
        lead_investor: "Abel Tesfaye",
        industry: "Financial Software",
        location: "Los Angeles, CA",
        deal_synopsis: "MoonPay USA raised $555.0 million in Series A on April 13, 2022. The round included participation from 11:11 Media, 1/1 Capital, 7feur and 118 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Victor Faramond",
        investors: [
          {
            name: "11:11 Media",
            status: "New Investor",
            lead: false
          },
          {
            name: "1/1 Capital",
            status: "New Investor",
            lead: false
          },
          {
            name: "7feur",
            status: "New Investor",
            lead: false
          },
          {
            name: "Abel Tesfaye",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Adel Nur",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Afshin Shahidi",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "AG Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Ahmir Thompson",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Alecla7",
            status: "New Investor",
            lead: false
          },
          {
            name: "Amir Esmailian",
            status: "Lead Investor",
            lead: true
          }
        ],
        financials: {
          revenue_ttm: 150000000,
          ebitda: 0,
          net_income: 0,
          burn_rate: 476809,
          runway_months: 19
        }
      },
      {
        deal_id: "deal-gp-4",
        company_name: "Legacy (Devices and Supplies)",
        company_id: "232830-28",
        deal_number: 4,
        deal_date: "2021-04-14",
        round_type: "Series A1",
        amount_invested: 499999.95,
        total_round_size: 9999999,
        post_money_valuation: 40000000,
        ownership_percentage: "0.84",
        lead_investor: "Abel Tesfaye",
        industry: "Other Devices and Supplies",
        location: "Los Angeles, CA",
        deal_synopsis: "Legacy (Devices and Supplies) raised $10.0 million in Series A1 on April 14, 2021. The round included participation from Abel Tesfaye, Chestnut Street Ventures, FirstMark Capital and 8 others.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "Khaled Kteily",
        investors: [
          {
            name: "Abel Tesfaye",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Chestnut Street Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "FirstMark Capital",
            status: "New Investor",
            lead: false
          },
          {
            name: "Justin Bieber",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Khaled Mohamed Khaled",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Orlando Bloom",
            status: "Lead Investor",
            lead: true
          },
          {
            name: "Oyster Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "Peak State Ventures",
            status: "New Investor",
            lead: false
          },
          {
            name: "The MBA Fund",
            status: "New Investor",
            lead: false
          },
          {
            name: "TQ Ventures",
            status: "New Investor",
            lead: false
          }
        ],
        financials: {
          revenue_ttm: 4321,
          ebitda: 0,
          net_income: 0,
          burn_rate: 249004,
          runway_months: 15
        }
      },
      {
        deal_id: "deal-gp-5",
        company_name: "Liquid I.V.",
        company_id: "112924-99",
        deal_number: 5,
        deal_date: "2019-07-24",
        round_type: "Later Stage VC",
        amount_invested: 250000,
        total_round_size: 5000000,
        post_money_valuation: 50000000,
        ownership_percentage: "0.55",
        lead_investor: "Gwyneth Paltrow",
        industry: "Food Products",
        location: "Los Angeles, CA",
        deal_synopsis: "Liquid I.V. raised $5.0 million in Later Stage VC on July 24, 2019. The round included participation from Gwyneth Paltrow.",
        deal_status: "Completed",
        financing_source: "Venture Capital",
        company_status: "Generating Revenue",
        ceo: "N/A",
        investors: [
          {
            name: "Gwyneth Paltrow",
            status: "New Investor",
            lead: false
          }
        ],
        financials: {
          revenue_ttm: 1000000000,
          ebitda: 0,
          net_income: 0,
          burn_rate: 1093286,
          runway_months: 22
        }
      }
    ],
    investments: [
      {
        company_name: "TMRW Sports",
        company_id: "506937-88",
        status: "Active",
        initial_investment: 750000,
        current_value: 1302429,
        multiple: "1.7",
        industry: "Publishing",
        investment_date: "2023-03-21",
        round_type: "Early Stage VC"
      },
      {
        company_name: "Legacy (Devices and Supplies)",
        company_id: "232830-28",
        status: "Active",
        initial_investment: 1250000.1,
        current_value: 3401709,
        multiple: "2.7",
        industry: "Other Devices and Supplies",
        investment_date: "2022-05-12",
        round_type: "Series B"
      },
      {
        company_name: "MoonPay USA",
        company_id: "266376-70",
        status: "Active",
        initial_investment: 27750000,
        current_value: 98215602,
        multiple: "3.5",
        industry: "Financial Software",
        investment_date: "2022-04-13",
        round_type: "Series A"
      },
      {
        company_name: "Legacy (Devices and Supplies)",
        company_id: "232830-28",
        status: "Active",
        initial_investment: 499999.95,
        current_value: 2037230,
        multiple: "4.1",
        industry: "Other Devices and Supplies",
        investment_date: "2021-04-14",
        round_type: "Series A1"
      },
      {
        company_name: "Liquid I.V.",
        company_id: "112924-99",
        status: "Active",
        initial_investment: 250000,
        current_value: 495641,
        multiple: "2.0",
        industry: "Food Products",
        investment_date: "2019-07-24",
        round_type: "Later Stage VC"
      },
      {
        company_name: "Rumble Fitness",
        company_id: "171639-28",
        status: "Active",
        initial_investment: 1075000,
        current_value: 3057709,
        multiple: "2.8",
        industry: "Leisure Facilities",
        investment_date: "2018-04-25",
        round_type: "Early Stage VC"
      }
    ],
    exits: [
      {
        company_name: "Rumble Fitness",
        company_id: "171639-28",
        exit_type: "Buyout/LBO (Add-on)",
        exit_date: "2021-03-24",
        initial_investment: 476307,
        exit_value: 1629825,
        multiple: "3.4",
        holding_period_years: "2.7",
        acquirer: "Nestle"
      },
      {
        company_name: "Liquid I.V.",
        company_id: "112924-99",
        exit_type: "Merger/Acquisition",
        exit_date: "2020-09-01",
        initial_investment: 1162922,
        exit_value: 2509367,
        multiple: "2.2",
        holding_period_years: "4.4",
        acquirer: "P&G"
      },
      {
        company_name: "Spotify",
        company_id: "40997-08",
        exit_type: "IPO",
        exit_date: "2018-04-03",
        initial_investment: 1078566,
        exit_value: 4324637,
        multiple: "4.0",
        holding_period_years: "2.2"
      }
    ],
    co_investors: [
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      },
      {
        firm: "Independent",
        shared_deals: 1,
        notable_co_investments: [
          "Various startups"
        ]
      }
    ],
    has_full_data: true
  },
  
  // CARD DATA ONLY - These 34 show on grid but have limited data
  "106502-68": {
    investor_name: "Will Smith",
    investor_pb_id: "106502-68",
    display_role: "Founder, Dreamers VC",
    total_investments: 25,
    active_portfolio: 19,
    total_exits: 7,
    total_invested_active: 45000000,
    total_invested_previous: 120000000,
    latest_company: "Masterclass",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Media", "Entertainment", "EdTech"],
    activity_tier: "Active",
    exit_rate: 28.0,
    has_full_data: false
  },
  
  "230398-75": {
    investor_name: "Nico Rosberg",
    investor_pb_id: "230398-75",
    display_role: "Angel Investor",
    total_investments: 24,
    active_portfolio: 19,
    total_exits: 5,
    total_invested_active: 25000000,
    total_invested_previous: 40000000,
    latest_company: "Lilium",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Mobility", "CleanTech", "Sports Tech"],
    activity_tier: "Moderate",
    exit_rate: 20.8,
    has_full_data: false
  },
  
  "108080-02": {
    investor_name: "William Adams",
    investor_pb_id: "108080-02",
    display_role: "Founder, i.am+",
    total_investments: 17,
    active_portfolio: 13,
    total_exits: 4,
    total_invested_active: 20000000,
    total_invested_previous: 35000000,
    latest_company: "Beats Electronics",
    latest_investment_timeago: "5 months ago",
    preferred_industries: ["Consumer Electronics", "Music Tech", "AI"],
    activity_tier: "Moderate",
    exit_rate: 23.5,
    has_full_data: false
  },
  
  "119058-04": {
    investor_name: "Shawn Mendes",
    investor_pb_id: "119058-04",
    display_role: "Angel Investor",
    total_investments: 11,
    active_portfolio: 9,
    total_exits: 2,
    total_invested_active: 8000000,
    total_invested_previous: 12000000,
    latest_company: "Sofi",
    latest_investment_timeago: "3 weeks ago",
    preferred_industries: ["FinTech", "Music", "Social Impact"],
    activity_tier: "Emerging",
    exit_rate: 18.2,
    has_full_data: false
  },
  
  "232331-50": {
    investor_name: "Drew Brees",
    investor_pb_id: "232331-50",
    display_role: "Co-Founder, Brees Dream Foundation",
    total_investments: 10,
    active_portfolio: 7,
    total_exits: 3,
    total_invested_active: 15000000,
    total_invested_previous: 25000000,
    latest_company: "Walk-On's Sports Bistreaux",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Food & Beverage", "Sports Tech", "Real Estate"],
    activity_tier: "Emerging",
    exit_rate: 30.0,
    has_full_data: false
  },
  
  "115294-24": {
    investor_name: "Justin Bieber",
    investor_pb_id: "115294-24",
    display_role: "Angel Investor",
    total_investments: 9,
    active_portfolio: 4,
    total_exits: 5,
    total_invested_active: 12000000,
    total_invested_previous: 30000000,
    latest_company: "Spotify",
    latest_investment_timeago: "6 months ago",
    preferred_industries: ["Music Tech", "Social Media", "Gaming"],
    activity_tier: "Moderate",
    exit_rate: 55.6,
    has_full_data: false
  },
  
  "229982-68": {
    investor_name: "Cindy Crawford",
    investor_pb_id: "229982-68",
    display_role: "Co-Founder, Meaningful Beauty",
    total_investments: 8,
    active_portfolio: 6,
    total_exits: 2,
    total_invested_active: 10000000,
    total_invested_previous: 18000000,
    latest_company: "Moon Juice",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Beauty", "Wellness", "Fashion"],
    activity_tier: "Emerging",
    exit_rate: 25.0,
    has_full_data: false
  },
  
  "162893-62": {
    investor_name: "Kerry Washington",
    investor_pb_id: "162893-62",
    display_role: "Founder, Simpson Street",
    total_investments: 8,
    active_portfolio: 6,
    total_exits: 2,
    total_invested_active: 12000000,
    total_invested_previous: 20000000,
    latest_company: "The Wing",
    latest_investment_timeago: "4 months ago",
    preferred_industries: ["Media", "Social Impact", "Women-led"],
    activity_tier: "Emerging",
    exit_rate: 25.0,
    has_full_data: false
  },
  
  "129039-04": {
    investor_name: "Beyonce Knowles-Carter",
    investor_pb_id: "129039-04",
    display_role: "Founder, Parkwood Entertainment",
    total_investments: 8,
    active_portfolio: 6,
    total_exits: 2,
    total_invested_active: 25000000,
    total_invested_previous: 45000000,
    latest_company: "Sidestep",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Entertainment", "Fashion", "Tech"],
    activity_tier: "Moderate",
    exit_rate: 25.0,
    has_full_data: false
  },
  
  "158374-18": {
    investor_name: "Mindy Kaling",
    investor_pb_id: "158374-18",
    display_role: "Angel Investor",
    total_investments: 8,
    active_portfolio: 7,
    total_exits: 1,
    total_invested_active: 6000000,
    total_invested_previous: 8000000,
    latest_company: "Swish Beverages",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Consumer Brands", "Media", "D2C"],
    activity_tier: "Emerging",
    exit_rate: 12.5,
    has_full_data: false
  },
  
  "227467-00": {
    investor_name: "Cristiano Ronaldo",
    investor_pb_id: "227467-00",
    display_role: "Founder, CR7 Ventures",
    total_investments: 7,
    active_portfolio: 6,
    total_exits: 1,
    total_invested_active: 30000000,
    total_invested_previous: 40000000,
    latest_company: "Tatel Restaurants",
    latest_investment_timeago: "3 weeks ago",
    preferred_industries: ["Sports Tech", "Hospitality", "Fitness"],
    activity_tier: "Emerging",
    exit_rate: 14.3,
    has_full_data: false
  },
  
  "226803-61": {
    investor_name: "Russell Wilson",
    investor_pb_id: "226803-61",
    display_role: "Co-Founder, West2East Empire",
    total_investments: 7,
    active_portfolio: 4,
    total_exits: 3,
    total_invested_active: 8000000,
    total_invested_previous: 15000000,
    latest_company: "Molecule Mattresses",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Sports Tech", "Health", "Consumer"],
    activity_tier: "Emerging",
    exit_rate: 42.9,
    has_full_data: false
  },
  
  "156628-81": {
    investor_name: "Zoe Saldana",
    investor_pb_id: "156628-81",
    display_role: "Co-Founder, Cinestar Pictures",
    total_investments: 6,
    active_portfolio: 6,
    total_exits: 0,
    total_invested_active: 5000000,
    total_invested_previous: 5000000,
    latest_company: "BESE",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Media", "Fashion", "Social Impact"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "149097-43": {
    investor_name: "Chris Evans",
    investor_pb_id: "149097-43",
    display_role: "Angel Investor",
    total_investments: 6,
    active_portfolio: 6,
    total_exits: 0,
    total_invested_active: 7000000,
    total_invested_previous: 7000000,
    latest_company: "A Starting Point",
    latest_investment_timeago: "4 months ago",
    preferred_industries: ["Media", "Civic Tech", "Entertainment"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "118590-58": {
    investor_name: "Katy Perry",
    investor_pb_id: "118590-58",
    display_role: "Angel Investor",
    total_investments: 6,
    active_portfolio: 6,
    total_exits: 0,
    total_invested_active: 8000000,
    total_invested_previous: 8000000,
    latest_company: "Popchips",
    latest_investment_timeago: "3 months ago",
    preferred_industries: ["Consumer Brands", "Food & Beverage", "Tech"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "169015-24": {
    investor_name: "Natalie Portman",
    investor_pb_id: "169015-24",
    display_role: "Angel Investor",
    total_investments: 6,
    active_portfolio: 4,
    total_exits: 2,
    total_invested_active: 6000000,
    total_invested_previous: 10000000,
    latest_company: "Therabody",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Wellness", "Social Impact", "CleanTech"],
    activity_tier: "Emerging",
    exit_rate: 33.3,
    has_full_data: false
  },
  
  "168399-55": {
    investor_name: "Rosario Dawson",
    investor_pb_id: "168399-55",
    display_role: "Co-Founder, Studio 189",
    total_investments: 6,
    active_portfolio: 5,
    total_exits: 1,
    total_invested_active: 4000000,
    total_invested_previous: 6000000,
    latest_company: "Vegan Nation",
    latest_investment_timeago: "5 months ago",
    preferred_industries: ["Social Impact", "Sustainability", "Media"],
    activity_tier: "Emerging",
    exit_rate: 16.7,
    has_full_data: false
  },
  
  "187464-52": {
    investor_name: "Trevor Noah",
    investor_pb_id: "187464-52",
    display_role: "Founder, Day Zero Productions",
    total_investments: 6,
    active_portfolio: 6,
    total_exits: 0,
    total_invested_active: 5000000,
    total_invested_previous: 5000000,
    latest_company: "Chicken Soup for the Soul",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Media", "EdTech", "African Tech"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "109576-36": {
    investor_name: "Jennifer Lopez",
    investor_pb_id: "109576-36",
    display_role: "Founder, Nuyorican Productions",
    total_investments: 5,
    active_portfolio: 4,
    total_exits: 1,
    total_invested_active: 15000000,
    total_invested_previous: 20000000,
    latest_company: "Hims & Hers",
    latest_investment_timeago: "3 months ago",
    preferred_industries: ["Beauty", "Fashion", "Health"],
    activity_tier: "Emerging",
    exit_rate: 20.0,
    has_full_data: false
  },
  
  "203875-57": {
    investor_name: "Logan Paul",
    investor_pb_id: "203875-57",
    display_role: "Co-Founder, Maverick Media",
    total_investments: 5,
    active_portfolio: 2,
    total_exits: 3,
    total_invested_active: 3000000,
    total_invested_previous: 8000000,
    latest_company: "Liquid Death",
    latest_investment_timeago: "2 weeks ago",
    preferred_industries: ["Consumer Brands", "Crypto", "Media"],
    activity_tier: "Emerging",
    exit_rate: 60.0,
    has_full_data: false
  },
  
  "240736-69": {
    investor_name: "Demi Lovato",
    investor_pb_id: "240736-69",
    display_role: "Angel Investor",
    total_investments: 5,
    active_portfolio: 4,
    total_exits: 1,
    total_invested_active: 3000000,
    total_invested_previous: 5000000,
    latest_company: "CAST Centers",
    latest_investment_timeago: "4 months ago",
    preferred_industries: ["Mental Health", "Wellness", "Social Impact"],
    activity_tier: "Emerging",
    exit_rate: 20.0,
    has_full_data: false
  },
  
  "222086-17": {
    investor_name: "Kate Hudson",
    investor_pb_id: "222086-17",
    display_role: "Co-Founder, Fabletics",
    total_investments: 4,
    active_portfolio: 3,
    total_exits: 1,
    total_invested_active: 8000000,
    total_invested_previous: 12000000,
    latest_company: "InBloom",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Fashion", "Wellness", "Fitness"],
    activity_tier: "Emerging",
    exit_rate: 25.0,
    has_full_data: false
  },
  
  "241323-76": {
    investor_name: "David Guetta",
    investor_pb_id: "241323-76",
    display_role: "Angel Investor",
    total_investments: 4,
    active_portfolio: 2,
    total_exits: 2,
    total_invested_active: 5000000,
    total_invested_previous: 10000000,
    latest_company: "Cross Mint",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Music Tech", "NFT", "Nightlife"],
    activity_tier: "Emerging",
    exit_rate: 50.0,
    has_full_data: false
  },
  
  "222464-98": {
    investor_name: "Reese Witherspoon",
    investor_pb_id: "222464-98",
    display_role: "Founder, Hello Sunshine",
    total_investments: 4,
    active_portfolio: 3,
    total_exits: 1,
    total_invested_active: 10000000,
    total_invested_previous: 15000000,
    latest_company: "Athletic Greens",
    latest_investment_timeago: "3 weeks ago",
    preferred_industries: ["Media", "Women-led", "Consumer"],
    activity_tier: "Emerging",
    exit_rate: 25.0,
    has_full_data: false
  },
  
  "254753-92": {
    investor_name: "Demi Moore",
    investor_pb_id: "254753-92",
    display_role: "Angel Investor",
    total_investments: 4,
    active_portfolio: 4,
    total_exits: 0,
    total_invested_active: 3000000,
    total_invested_previous: 3000000,
    latest_company: "Andie Swim",
    latest_investment_timeago: "5 months ago",
    preferred_industries: ["Fashion", "Beauty", "Wellness"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "250541-29": {
    investor_name: "Anne Hathaway",
    investor_pb_id: "250541-29",
    display_role: "Angel Investor",
    total_investments: 3,
    active_portfolio: 3,
    total_exits: 0,
    total_invested_active: 2000000,
    total_invested_previous: 2000000,
    latest_company: "The Honest Company",
    latest_investment_timeago: "6 months ago",
    preferred_industries: ["Sustainability", "Consumer", "Social Impact"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "277486-03": {
    investor_name: "Simu Liu",
    investor_pb_id: "277486-03",
    display_role: "Angel Investor",
    total_investments: 3,
    active_portfolio: 3,
    total_exits: 0,
    total_invested_active: 1500000,
    total_invested_previous: 1500000,
    latest_company: "Bobba",
    latest_investment_timeago: "1 month ago",
    preferred_industries: ["Asian-founded", "Food & Beverage", "Entertainment"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "264090-43": {
    investor_name: "Olivia Munn",
    investor_pb_id: "264090-43",
    display_role: "Angel Investor",
    total_investments: 2,
    active_portfolio: 0,
    total_exits: 2,
    total_invested_active: 0,
    total_invested_previous: 3000000,
    latest_company: "Uber",
    latest_investment_timeago: "5 years ago",
    preferred_industries: ["Tech", "Media", "Consumer"],
    activity_tier: "Inactive",
    exit_rate: 100.0,
    has_full_data: false
  },
  
  "223036-30": {
    investor_name: "Jennifer Aniston",
    investor_pb_id: "223036-30",
    display_role: "Angel Investor",
    total_investments: 2,
    active_portfolio: 1,
    total_exits: 1,
    total_invested_active: 5000000,
    total_invested_previous: 8000000,
    latest_company: "Vital Proteins",
    latest_investment_timeago: "8 months ago",
    preferred_industries: ["Wellness", "Beauty", "Consumer"],
    activity_tier: "Emerging",
    exit_rate: 50.0,
    has_full_data: false
  },
  
  "258501-52": {
    investor_name: "Nina Dobrev",
    investor_pb_id: "258501-52",
    display_role: "Angel Investor",
    total_investments: 2,
    active_portfolio: 2,
    total_exits: 0,
    total_invested_active: 1000000,
    total_invested_previous: 1000000,
    latest_company: "Maverick Ventures",
    latest_investment_timeago: "3 months ago",
    preferred_industries: ["Health", "Wellness", "Consumer"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "268355-08": {
    investor_name: "Olivia Culpo",
    investor_pb_id: "268355-08",
    display_role: "Angel Investor",
    total_investments: 1,
    active_portfolio: 1,
    total_exits: 0,
    total_invested_active: 500000,
    total_invested_previous: 500000,
    latest_company: "Vide",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Beverage", "Wellness", "Lifestyle"],
    activity_tier: "Emerging",
    exit_rate: 0,
    has_full_data: false
  },
  
  "222892-48": {
    investor_name: "Ellen DeGeneres",
    investor_pb_id: "222892-48",
    display_role: "Angel Investor",
    total_investments: 15,
    active_portfolio: 12,
    total_exits: 3,
    total_invested_active: 20000000,
    total_invested_previous: 30000000,
    latest_company: "Headspace",
    latest_investment_timeago: "4 months ago",
    preferred_industries: ["Wellness", "Pet Care", "Media"],
    activity_tier: "Moderate",
    exit_rate: 20.0,
    has_full_data: false
  },
  
  "277901-83": {
    investor_name: "Priyanka Chopra",
    investor_pb_id: "277901-83",
    display_role: "Angel Investor",
    total_investments: 12,
    active_portfolio: 10,
    total_exits: 2,
    total_invested_active: 8000000,
    total_invested_previous: 12000000,
    latest_company: "Bumble",
    latest_investment_timeago: "2 months ago",
    preferred_industries: ["Women-led", "Tech", "Social Impact"],
    activity_tier: "Moderate",
    exit_rate: 16.7,
    has_full_data: false
  },
  
  "279518-41": {
    investor_name: "Serena Williams",
    investor_pb_id: "279518-41",
    display_role: "Founder, Serena Ventures",
    total_investments: 85,
    active_portfolio: 60,
    total_exits: 25,
    total_invested_active: 111000000,
    total_invested_previous: 150000000,
    latest_company: "Esusu",
    latest_investment_timeago: "1 week ago",
    preferred_industries: ["Women-led", "Minority-led", "Tech"],
    activity_tier: "Mega Active",
    exit_rate: 29.4,
    has_full_data: false
  }
};

// Helper function to get celebrity by ID
export const getCelebrityById = (pb_id) => {
  return mockCelebrities[pb_id] || null;
};

// Helper function to get all celebrities
export const getAllCelebrities = () => {
  return Object.values(mockCelebrities);
};

// Helper function to get celebrities by activity tier
export const getCelebritiesByTier = (tier) => {
  return Object.values(mockCelebrities).filter(celeb => celeb.activity_tier === tier);
};

// Helper function to get only celebrities with full data
export const getFullDataCelebrities = () => {
  return Object.values(mockCelebrities).filter(celeb => celeb.has_full_data);
};